import { useEffect, useState } from 'react';

const useDeviceList = (kind, refreshKey) => {
	const [devices, setDevices] = useState([]);

	useEffect(() => {
		let cancelled = false;

		const refresh = () => navigator.mediaDevices?.enumerateDevices()
			.then(found => !cancelled && setDevices(found.filter(device => device.kind === kind)))
			.catch(() => {});

		refresh();

		navigator.mediaDevices?.addEventListener('devicechange', refresh);

		return () => {
			cancelled = true;
			navigator.mediaDevices?.removeEventListener('devicechange', refresh);
		};
	}, [kind, refreshKey]);

	return devices;
};

export default useDeviceList;
